import either, { right } from "../../../../lib/either";
import DepParentsRemoteDataSource from "../../datasources/dep_parents_remote_datasource";

export const ValidateInvoiceProfileStatusUseCase = (userId) =>
  either(async () => {
    const isCompleted =
      await DepParentsRemoteDataSource.getIsInvoiceProfileCompleted(userId);

    return right({ status: isCompleted });
  });
